// Normalizes a section's document-type fields (declared in section_field_meta)
// into {id, src, label} entries ready for display - only for sections backed
// by simple Gas FK fields. Sections whose pictures come from a separate
// Document query (see GasPictures's CUSTOM_PICTURE_SECTIONS) never have
// anything here, since they have no declared fields at all.
const getSectionPictureDocuments = (section, gas) => {
  const fields = gas?.section_field_meta?.[section.key]?.fields || [];
  const documentFields = fields.filter(({type}) => type === 'document');

  return documentFields
    .map(({field, label}) => {
      const doc = gas?.[field];
      return !doc ? null : {id: doc.id, src: doc.document_file, label};
    })
    .filter(Boolean);
};

export default getSectionPictureDocuments;
